import { render, staticRenderFns } from "./CiftTable.vue?vue&type=template&id=460f9375"
import script from "./CiftTable.vue?vue&type=script&lang=ts"
export * from "./CiftTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports